export default "/images/vendor/flag-icons/flags/1x1/bh.svg?d6e3bed59974f2b0aeddc9c6cd16d825";